<p-fieldset class="fieldsetReports" *ngFor="let groupAND of this.filters.filtersGroupAND; let i = index">
  <ng-template pTemplate="header" *ngIf="i==0">Condición</ng-template>
  <ng-template pTemplate="header" *ngIf="i!=0">
    Y Condición
  </ng-template>
  <div class="p-grid" *ngFor="let groupOR of groupAND.filtersGroupOR; let j = index">
    <div class="p-col p-col-3 p-field">
      {{getNameField(groupOR)}}
    </div>
    <div class="p-col p-col-3 p-field">
      <p-dropdown appendTo="body" [options]="filterConditionsValues[groupOR.entity_field_id]"
        [(ngModel)]="groupOR.condition_value" placeholder="Seleccione" optionLabel="name" optionValue="value"
        [showClear]="true" appendTo="body" [disabled]="!groupOR.ask_user" [ngModelOptions]="{standalone: true}">
      </p-dropdown>
    </div>
    <div class="p-col p-col p-field" *ngIf="groupOR.condition_value != 'null' && groupOR.condition_value != '!null'">
      <input *ngIf="getFilterOptionsOrValueType(groupOR, false) == 'input-text'" [ngModelOptions]="{standalone: true}"
             type="text" pInputText [(ngModel)]="groupOR.value" />

      <p-dropdown *ngIf="getFilterOptionsOrValueType(groupOR, false) == 'input-dropdown'"
                  [options]="filterValuesOptions[groupOR.entity_field_id]"
                  [(ngModel)]="groupOR.value"
                  placeholder="Seleccione"
                  optionLabel="text"
                  optionValue="code"
                  [showClear]="true" appendTo="body" [filter]="true" (onFilter)="onFilter($event, groupOR)"
                  [ngModelOptions]="{standalone: true}"></p-dropdown>

      <p-dropdown appendTo="body" *ngIf="(getFilterOptionsOrValueType(groupOR, false)=='input-datetime')"
                  [options]="date_options" [(ngModel)]="groupOR.value_date" placeholder="Seleccione" optionLabel="name"
                  optionValue="value" [ngModelOptions]="{standalone: true}"></p-dropdown>

      <p-calendar *ngIf="getFilterOptionsOrValueType(groupOR, false) == 'input-datetime'&&groupOR.value_date=='date'"
                  dateFormat="dd/mm/yy" hourFormat="24" [showIcon]="true" [showTime]="true" [(ngModel)]="groupOR.value"
                  appendTo="body" [ngModelOptions]="{standalone: true}" [stepMinute]="15"></p-calendar>

      <p-multiSelect *ngIf="getFilterOptionsOrValueType(groupOR, false) == 'dropdown-multiple'"
                     [options]="filterValuesOptions[groupOR.entity_field_id]" [(ngModel)]="groupOR.value_multiple" optionLabel="text"
                     optionValue="code" placeholder="Seleccione" [filter]="true" [showClear]="true" appendTo="body"
                     [ngModelOptions]="{standalone: true}"></p-multiSelect>

      <input *ngIf="getFilterOptionsOrValueType(groupOR, false) == 'input-number'" [ngModelOptions]="{standalone: true}"
             type="number" pInputText [(ngModel)]="groupOR.value" />
    </div>
  </div>
</p-fieldset>
<div class="p-col p-field p-right">
  <label>&nbsp;</label>
  <p-button label="Generar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
</div>
